<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="用户信息">
              <a-input placeholder="请输入用户名/姓名/身份证号/手机号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="注册方式">
              <a-select v-model="where.keyword.sourceType" allowClear @change="registerChange">
                <a-select-option :value="0">个人注册</a-select-option>
                <a-select-option :value="1">系统导入</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="注册日期">
              <a-range-picker
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                @change="onTimeChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="单位名称">
              <a-input placeholder="请输入" v-model="where.keyword.enterpriseName" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row  :gutter="24">
            <a-col :span="4">
                <a-form-item label="用户组">
                    <a-select
                            show-search
                            v-model="where.keyword.groupId"
                            :filter-option="filterOption"
                            allowClear
                            @change="groupChanged"
                    >
                        <a-select-option
                                :value="info.id"
                                v-for="(info, index) in grouplist"
                                :key="index"
                        >{{info.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="10">
                <a-form-item label="所在地区">
                    <a-cascader
                            :options="areas"
                            placeholder="请选择所在地区"
                            change-on-select
                            @change="onAreachange"
                            :default-value="areaList"
                            :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
                    />
                </a-form-item>
            </a-col>
            <a-col :span="4">
                <a-form-item label="主管部门">
                    <a-select
                            show-search
                            v-model="where.keyword.administration"
                            :filter-option="filterOption"
                            allowClear
                            @change="administrationChanged"
                    >
                        <a-select-option
                                :value="info.itemName"
                                v-for="(info, index) in administrationList"
                                :key="index"
                        >{{info.itemName}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="2" :style="{ textAlign: 'left' }">
                <a-button type="primary" @click="searchList" v-btnlimit="'个人用户列表-搜索'">搜索</a-button>
            </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo(0, 1)" type="primary" v-btnlimit="'个人用户列表-添加'"/>
      <pxkeji-btn name="下载模版" class="pxkeji_basic_btn" @click="downloadTemplate" type="primary" v-btnlimit="'个人用户列表-下载模版'"/>
      <pxkeji-btn name="导出用户" class="pxkeji_basic_btn" @click="exportData" type="primary" v-btnlimit="'个人用户列表-导出用户'"/>
      <pxkeji-btn name="导出照片" @click="exportPhoto" class="pxkeji_basic_btn" v-btnlimit="'个人用户列表-导出照片'"/>
      <pxkeji-btn
        name="批量启用"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        v-btnlimit="'个人用户列表-批量启用'"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        v-if="selectRows.length>0"
        v-btnlimit="'个人用户列表-批量禁用'"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />

      <a-upload
        name="file"
        :action="$api.student.importData"
        accept=".xls, .xlsx"
        v-btnlimit="'个人用户列表-导入用户'"
        @change="handleChange"
        :showUploadList="false"
      >
        <a-button>
          <a-icon type="upload" />导入用户
        </a-button>
      </a-upload>

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="sourceType" slot-scope="sourceType">
          <span v-if="sourceType==0">个人注册</span>
          <span v-else>系统导入</span>
        </span>

        <span slot="status" slot-scope="status">
          <a-tag v-if="status==0" color="red">禁用</a-tag>
          <a-tag v-else color="green">启用</a-tag>
        </span>

        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="编辑"
            :roles="[]"
            v-btnlimit="'个人用户列表-编辑'"
            @click="showInfo(action.id,2)"
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />

          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                  name="积分明细"
                  v-btnlimit="'个人用户列表-积分明细'"
                  :roles="[]"
                  @click="integralInfo(action)"
                  size="small"
                  type="dashed"
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                  name="重置密码"
                  v-btnlimit="'个人用户列表-重置密码'"
                  :roles="[]"
                  @click="resetPaw(action.id)"
                  size="small"
                  type="dashed"
                />
              </a-menu-item>
                   <a-menu-item key="3">
                <pxkeji-btn
                        name="已购课程"
                        :roles="[]"
                        v-btnlimit="'个人用户列表-已购课程'"
                        @click="payCourse(action.id)"
                        size="small"
                        type="dashed"
                />
              </a-menu-item>
              <a-menu-item key="4">
                <pxkeji-btn
                        name="删除"
                        :roles="[]"
                        v-btnlimit="'个人用户列表-删除'"
                        @click="remove(action.id)"
                        size="small"
                        type="dashed"
                />
              </a-menu-item>
              <a-menu-item key="5">
                <pxkeji-btn
                    name="解锁"
                    v-btnlimit="'个人用户列表-解锁'"
                    :roles="[]"
                    @click="unlocking(action.id)"
                    size="small"
                    type="dashed"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'个人用户列表-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>用户总人数：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :infos="addedit.info" />
    </a-modal>

    <a-modal
      title="积分明细"
      v-model="integral.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <integralRecord @callbackMethod="save" :infos="integral.info" />
    </a-modal>
    <a-modal
            v-model="courseModal.courseShow"
            :footer="false"
            destroyOnClose
            width="70%"
            :maskClosable="false"
            class="ui-modal"
    >
      <payCourse
              @callbackMethod="closeCourse"
              :id="courseModal.id"
      />
    </a-modal>

  </div>

</template>
<script>
var that;
import Info from "./personalInfo.vue"; //新增编辑
import integralRecord from "./integralRecord.vue"; //积分明细
import payCourse from "./payCourse.vue"; //已购课程
const columns = [
  {
    dataIndex: "fullName",
    key: "fullName",
    align: "center",
    title: "姓名"
  },
 /* {
    dataIndex: "sex",
    key: "sex",
    align: "center",
    title: "性别",
    scopedSlots: { customRender: "sex" }
  },*/
  // 2021 09 10 start
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "证件号"
  },
  // 2021 09 10 end
  /*{
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号"
  },*/
  // 2021 09 10 start
  {
    dataIndex: "province",
    key: "province",
    align: "center",
    title: "所在地区"
  },
  /*{
    dataIndex: "administration",
    key: "administration",
    align: "center",
    title: "主管部门"
  },*/
  // 2021 09 10 end

  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "添加时间"
  },
  {
    dataIndex: "sourceType",
    key: "sourceType",
    align: "center",
    title: "注册方式",
    scopedSlots: { customRender: "sourceType" }
  },
  {
    dataIndex: "company",
    key: "company",
    align: "center",
    title: "所属单位"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];
var excelLoading = "";
export default {
  name: "couponlist",
  data() {
    return {
      expand: false, //高级搜索
      // 2021 09 28 start
      areas:[],
      areaList: [],
      //2021 09 28 end
      administrationList: [], //2021 11 01
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      registerItem: [
        {
          value: "1",
          lable: "个人注册"
        },
        {
          value: "2",
          lable: "集体开课"
        }
      ],
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      //积分明细
      integral: {
        info: {},
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          startTime: "",
          endTime: "",
          enterpriseName: "",
          sourceType: "",
          company: "",
          administration:"",//2021 11 01
          // 2021 09 28 start
          groupId:"",
          province:'',
          city:'',
          area:'',
          // 2021 09 28 end
        }
      },
      courseModal: {
        courseShow: false,
        id: 0,
      },
      selectRows: [], //选中项编号
      isloading: false,
      grouplist: [],
      visible: false //弹框
    };
  },
  components: {
    Info,
    integralRecord,
    payCourse
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.getgrouplist();
      this.GetList();
      this.getarea(); //2021 09 28
      this.getDictionaryItem(); //2021 11 01
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {

    unlocking(id) {
      that = this;
      that.isloading = true;
      that.$api.user
          .unlockingUser(id)
          .then(res => {
            that.isloading = false;
            if (res.errorCode == that.$msg.responseCode.success) {
              that.$message.success(res.errorMsg);
              that.GetList();
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            that.isloading = false;
          });
    },
    // 2021 11 01 start
    //获取数据字典
      getDictionaryItem() {
        this.$api.dictionaryItem.tree(23).then((res) => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.administrationList = res.data;
          } else {
            this.error(res.errorMsg);
          }
        });

    },
    administrationChanged(v) {
        // 2021 11 04 start
          if(v){
              this.where.keyword.administration = v;
          }else{
              this.where.keyword.administration = '';
          }
          // 2021 11 04 end
    },
    // 2021 11 01 end
    // 2021 09 28 start
    onAreachange(v){
          // 2021 11 04 start
            if(v[0]){
              this.where.keyword.province=v[0];
            }else{
              this.where.keyword.province='';
            }
            if(v[1]){
              this.where.keyword.city=v[1];
            }else{
              this.where.keyword.city='';
            }
            if(v[2]){
              this.where.keyword.area=v[2];
            }else{
              this.where.keyword.area='';
            }
            // 2021 11 04 end
      },
    getarea(){
        this.areas=this.$api.city.city;
    },
    // 2021 09 28 end
    toggle() {
      this.expand = !this.expand;
    },
    groupChanged(v) {
      // 2021 11 04 start
        if(v){
            this.where.keyword.groupId = v;
        }else{
            this.where.keyword.groupId ='';
        }
        // 2021 11 04 end
    },
    getgrouplist() {
      this.isloading = true;
      this.$api.usergroup
        .getAll()
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.grouplist = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    // 2021 10 22 start
      filterOption(input, option) {
       return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      // 2021 10 22 end
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      var param = {
          pageNow: this.list.pagination.current,
          pageSize: this.list.pagination.defaultPageSize,
          startTime: this.where.keyword.startTime,
          endTime: this.where.keyword.endTime,
          name: this.where.keyword.name,
          enterpriseName: this.where.keyword.enterpriseName,
          province: this.where.keyword.province,
          city: this.where.keyword.city,
          area: this.where.keyword.area,
          groupId: this.where.keyword.groupId,
          administration:this.where.keyword.administration,
        };
        if (this.where.keyword.sourceType != "") {
          param.sourceType = this.where.keyword.sourceType;
        }
      this.$api.student
        .getPagedList(param)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            // 2021 09 11 start
            // this.list.datas = res.data.records;
            var item =res.data.records;
            for (let i = 0; i < item.length; i++) {
              if(item[i].city){
                item[i].province=item[i].province+"/"+item[i].city
              }
              if(item[i].area){
                item[i].province=item[i].province+"/"+item[i].area
              }
            }
            this.list.datas = item;
            // 2021 09 11 end
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    /**删除 */
    remove(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.student
                  .remove(id)
                  .then(res => {
                    that.isloading = false;
                    if (res.errorCode == that.$msg.responseCode.success) {
                      that.$message.success(res.errorMsg);
                      that.GetList();
                    } else {
                      that.$message.error(res.errorMsg);
                    }
                  })
                  .catch(() => {
                    that.isloading = false;
                  });
        },
        onCancel() {}
      });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    registerChange(item) {
      this.where.keyword.registerSource = item;
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id, type) {
      //打开弹出框
      if (type == 1) {
        this.addedit.title = "添加";
      } else {
        this.addedit.title = "详情";
      }
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.type = type;
    },
    /**积分明细 */
    integralInfo(data) {
      this.integral.visible = true;
      this.integral.info = data;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {},
        onCancel() {}
      });
    },
    payCourse(id) {
      this.courseModal.courseShow = true;
      console.log(id);
      this.courseModal.id = id;
    },
    closeCourse(id){
      this.courseModal.courseShow = false;
      this.courseModal.id = id;
    },
    resetPaw(id, password) {
      this.$confirm({
        title: "您确定要将密码重置为111111吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.student
            .resetPassword(id, "111111")
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    save() {
      this.addedit.visible = false;
      this.integral.visible = false;
      this.GetList();
    },
    downloadTemplate() {
      window.location.href = this.$api.student.downloadTemplate();
    },
    exportData() {
      window.location.href = this.$api.student.exportData(
        this.where.keyword.name,
        this.where.keyword.startTime,
        this.where.keyword.endTime,
        this.where.keyword.sourceType,
        this.where.keyword.enterpriseName,
        this.selectRows.join(),
        this.where.keyword.province,
        this.where.keyword.city,
        this.where.keyword.area,
        this.where.keyword.groupId,
        this.where.keyword.administration,
      );
    },
    exportPhoto() {
      window.location.href = this.$api.student.exportPhoto(
        this.where.keyword.name,
        this.where.keyword.startTime,
        this.where.keyword.endTime,
        this.where.keyword.sourceType,
        this.where.keyword.enterpriseName,
        this.selectRows.join()
      );
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handleChange(info) {
      if (info.file.status == "uploading") {
        if (excelLoading == "")
          excelLoading = this.$message.loading("上传中", 0);
      } else if (info.file.status == "done") {
        excelLoading();
        excelLoading = "";
        if (info.file.response.errorCode == this.$msg.responseCode.success) {
          this.$message.success(info.file.response.errorMsg);
        } else {
          this.$message.error(info.file.response.errorMsg);
        }
      }
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

